import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as SamlActions from './saml.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';

import { getAuth } from '../auth/auth.selectors';
import { SamlResponse } from './../../../app/@shared/models/saml_response.model';

@Injectable()
export class SamlEffects {
  constructor(private readonly actions$: Actions, private readonly store: Store, private readonly apiPublic: PublicPartnerApiService) { }

  loadSamls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SamlActions.loadSamls, SamlActions.removeSamlsSuccess, SamlActions.createSamlsSuccess, SamlActions.patchSamlsSuccess),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.get<Partial<SamlResponse>>('/partners/' + auth!.partner_uuid + '/auths/samls', {}).pipe(
            filter(result => result.samls !== undefined),
            map(result => {
              return SamlActions.loadSamlsSuccess({
                samls: result.samls!
              });
            }),
            catchError(error => of(SamlActions.loadSamlsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  createSamls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SamlActions.createSamls),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.post<{ object_uuid: string }>('/partners/' + auth!.partner_uuid + '/auths/samls', action.data).pipe(
            map(result => {
              return SamlActions.createSamlsSuccess({
                uuid: result.object_uuid
              });
            }),
            catchError(error => of(SamlActions.createSamlsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchSamls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SamlActions.patchSamls),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.patch<void>('/partners/' + auth!.partner_uuid + '/auths/samls/' + action.uuid, action.data).pipe(
            map(() => {
              return SamlActions.patchSamlsSuccess({
                uuid: action.uuid
              });
            }),
            catchError(error => of(SamlActions.patchSamlsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  removeSamls$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SamlActions.removeSamls),
      withLatestFrom(this.store.select(getAuth)),
      concatMap(
        ([action, auth]) =>
          this.apiPublic.delete<void>('/partners/' + auth!.partner_uuid + '/auths/samls/' + action.uuid).pipe(
            map(() => {
              return SamlActions.removeSamlsSuccess();
            }),
            catchError(error => of(SamlActions.removeSamlsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );
}
